import React from 'react';
import cx from 'classnames';

interface ContainerProps {
    className?: string;
    [props: string]: any;
}

const Container: React.FC<ContainerProps> = ({ className, children, ...props }) => {
    return (
        <div className={cx('w-5/6 mx-auto', className)} {...props}>
            {children}
        </div>
    );
};

export default Container;
